var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { Slot, SlotDirection } from "@/utils/types/layout";
import { useSlotVisibility } from "@/hooks/layout";
import AddWidgetControl from "@/components/layout/edit/addWidget";
import WidgetGrid from "../widgetGrid";
import { useFilteredWidgets } from "@/utils/themes/hooks";
/**
 *
 * Composant DockEast
 */
export default function DockEast() {
    var dockEastVisible = useSlotVisibility().dockEastVisible;
    var filteredWidgets = useFilteredWidgets(Slot.DOCK_EAST);
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    var areaVisible = (dockEastVisible && filteredWidgets.length > 0) || isEditingLayout;
    if (areaVisible) {
        if (filteredWidgets.length === 0 && !isEditingLayout) {
            return _jsx(_Fragment, {});
        }
        return (_jsxs("aside", __assign({ className: " ".concat(isEditingLayout && "border-[2px] border-[var(--colors-widget-border)]", "  flex-none flex flex-col bg-[var(--colors-dock-east-bg)] direction-vertical scroll-contain relative w-[16rem] h-full overflow-hidden\n      mt-[var(--margin-mt-dock-east)] mr-[var(--margin-mr-dock-east)]\n      mb-[var(--margin-mb-dock-east)] ml-[var(--margin-ml-dock-east)]") }, { children: [_jsx("div", __assign({ className: "relative w-full h-full overflow-hidden widgets-container scroll-elements" }, { children: _jsx(WidgetGrid, { direction: SlotDirection.VERTICAL, filteredWidgets: filteredWidgets, isEditingLayout: isEditingLayout }) })), isEditingLayout && _jsx(AddWidgetControl, { to: Slot.DOCK_EAST })] })));
    }
    return _jsx(_Fragment, {});
}
